import React, { useContext, useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import AppContext from '../context/appContext'
import MetaTags from 'react-meta-tags'

const slugify = (s = '') => s.toString().toLowerCase().trim().replace(/[_\s]+/g, '-').replace(/[^a-z0-9-]/g, '').replace(/-+/g, '-')

const BlogDetail = () => {
    const { slug } = useParams()
    const { fetchPostBySlug, posts, fetchPosts } = useContext(AppContext)
    const [post, setPost] = useState(null)
    const [loading, setLoading] = useState(true)
    const [blogsLoading, setBlogsLoading] = useState(true)
    const [moreBlogs, setMoreBlogs] = useState([])
    const [formData, setformData] = useState({ name: '', email: '', subject: '', phone: '', message: '', country: '' })
    const [formSubmitted, setformSubmitted] = useState(false)
    const [FormLoader, setFormLoader] = useState(false)

    useEffect(() => {
        (async () => {
            try { const data = await fetchPostBySlug(slug); setPost(data) } finally { setLoading(false) }
        })()
    }, [slug, fetchPostBySlug])

    useEffect(() => {
        (async () => { try { setBlogsLoading(true); await fetchPosts() } finally { setBlogsLoading(false) } })()
    }, [fetchPosts])

    useEffect(() => {
        const filtered = (posts || [])
            .filter(p => {
                const postSlug = (p.slug?.length) ? p.slug : slugify(p.metaTitle || p.title || '')
                return postSlug !== slug
            })
            .slice(0, 3)
        setMoreBlogs(filtered)
    }, [posts, slug])

    const submitMessage = async (e) => {
        e.preventDefault()
        setFormLoader(true)
        const response = await fetch("https://formsubmit.co/ajax/metatech674@gmail.com", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                _subject: "You have a new query from Metatech!",
                Name: formData.name,
                Email: formData.email,
                Contact: formData.phone,
                Country: formData.country,
                Subject: formData.subject,
                Message: formData.message,
                _template: 'box'

            })
        })
        const data = await response.json()
        console.log(data)
        setFormLoader(false)
        setformSubmitted(true)
        const formElements = document.getElementsByClassName('form-control')
        for (let index = 0; index < formElements.length; index++) {
            const element = formElements[index];
            element.setAttribute('disabled', 'true')
        }
    }

    if (loading) return (
        <div style={{ backgroundColor: '#151619', minHeight: '60vh' }} className="d-flex align-items-center justify-content-center">
            <div className="spinner-border text-light" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
    )
    if (!post) return <div className="text-center text-light py-5" style={{ backgroundColor: '#151619', minHeight: '50vh' }}>Not found</div>

    const path = window.location.pathname;
    const normalizedPath = path.endsWith("/") ? path : path + "/";
    return (
        <div style={{ backgroundColor: '#151619', minHeight: '100vh' }}>
            <MetaTags>
                <title>{post.metaTitle || post.title || 'Blog'}</title>
                <meta name="description" content={post.metaDescription || 'Blog article'} />
                <link rel="canonical" href={"https://metatech-official.com" + normalizedPath} />
            </MetaTags>
            <div className="container text-light">
                <div className="py-5">
                    <div className="pt-5">
                        <div className={`${window.innerWidth < 992 ? "" : "pt-5"}`}>
                            <h1 className="">{post.title}</h1>
                            <div className="text-secondary mb-3">{new Date(post.date || Date.now()).toLocaleString()} • {post.category || 'General'}</div>
                            {post.image && <img src={`https://res.cloudinary.com/l7pafu4a/image/fetch/f_webp/q_60/${post.image}`} alt={post.title} className="img-fluid rounded-4 mb-4" />}
                            <div className="card bg-transparent border-0">
                                <div className="card-body px-0 text-white" dangerouslySetInnerHTML={{ __html: post.description || '' }} />
                            </div>
                        </div>
                    </div>
                </div>

                <h5 className='text-center' style={{ fontWeight:"bold", textUnderlineOffset: "6px", color: '#6565ff' }}>SEND YOUR</h5>

                <div className="row justify-content-center">
                    <div className="col-12 col-md-6">
                        <div className="d-flex justify-content-center">
                            <h4 style={{ color: "white" }} className="display-4 my-4 ">Free Web & App Creation Proposal</h4>
                        </div>
                        <form onSubmit={(e) => submitMessage(e)}>
                            <div>
                                <input required onChange={(e) => setformData({ ...formData, name: e.target.value })} value={formData.name} name='Name' type="text" className="form-control rounded-4 p-3" id="exampleFormControlInput1" placeholder="Enter your name" />
                                <div className="d-flex">
                                    <input required onChange={(e) => setformData({ ...formData, email: e.target.value })} value={formData.email} name='email' type="email" className="form-control rounded-4 p-3 my-2 " style={{ marginRight: '0.5rem' }} id="exampleFormControlInput1" placeholder="Enter Your Email" />
                                    <input required onChange={(e) => setformData({ ...formData, phone: e.target.value })} value={formData.phone} name='number' type="number" className="form-control rounded-4 p-3 my-2" id="exampleFormControlInput1" placeholder="Phone Number" />

                                </div>
                                <div className="d-flex">
                                    <input required onChange={(e) => setformData({ ...formData, country: e.target.value })} value={formData.country} name='country' type="text" className="form-control rounded-4 p-3 my-2 " style={{ marginRight: '0.5rem' }} id="exampleFormControlInput1" placeholder="Country" />
                                    <input required onChange={(e) => setformData({ ...formData, subject: e.target.value })} value={formData.subject} name='subject' type="text" className="form-control rounded-4 p-3 my-2" id="exampleFormControlInput1" placeholder="Subject" />

                                </div>
                            </div>
                            <div className="mb-3">

                                <textarea required onChange={(e) => setformData({ ...formData, message: e.target.value })} value={formData.message} name='Message' placeholder='Your Question' className="form-control rounded-4 p-3 my-2" id="exampleFormControlTextarea1" rows="3"></textarea>
                            </div>
                            <div className="py-3 d-flex justify-content-center">
                                <button disabled={FormLoader || formSubmitted ? true : false} style={{ transition: 'all 1s ease' }} className={`btn btn-${formSubmitted ? 'success' : 'primary'} rounded-4 p-3 d-flex align-items-center`}>{formSubmitted ? 'Submitted' : 'Send Message'}
                                    {FormLoader && <div className="spinner-border text-light mx-2" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>}
                                </button>
                            </div>
                            {formSubmitted && <h4 className="display-6 text-success">Thanks for sending us a proposal, our subordinate will get back to you shortly for your further queries!</h4>}

                        </form>
                    </div>
                </div>

                {/* Learn More Blogs Section */}
                {(blogsLoading || moreBlogs.length > 0) && (
                    <div className="py-5">
                        <h5 className='text-center' style={{ fontWeight:"bold", textUnderlineOffset: '6px', color: '#6565ff' }}>EXPLORE</h5>
                        <h3 className="text-white text-center display-5 fw-bold mb-4">More Blog Articles</h3>
                        {blogsLoading ? (
                            <div className="d-flex justify-content-center py-5">
                                <div className="spinner-border text-light" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        ) : <div className="row">
                            {moreBlogs.map(p => {
                                const blogSlug = (p.slug?.length) ? p.slug : slugify(p.metaTitle || p.title || '')
                                return (
                                    <div key={p._id} className="col-sm-6 col-lg-4 col-12 my-2">
                                        <Link onClick={() => window.scrollTo({ behavior: 'smooth', top: 0, left: 0 })} to={`/blog/${blogSlug}/`} style={{ textDecoration: 'none' }}>
                                            <div className="card text-light rounded-4 h-100 overflow-hidden" style={{ borderColor: 'rgb(101, 101, 255)', backgroundColor: 'rgba(0, 0, 0, 0)' }}>
                                                {p.image && <img src={`https://res.cloudinary.com/l7pafu4a/image/fetch/f_webp/q_60/${p.image}`} className="card-img-top" alt={p.title || 'blog image'} />}
                                                <div className="card-body justify-content-end d-flex flex-column text-start">
                                                    <h2 className="card-title text-light text-opacity-75 h6">{p.category || 'General'}</h2>
                                                    <h2 className="card-title h5">{p.title || 'Untitled Post'}</h2>
                                                    <p className="card-text">{new Date(p.date || Date.now()).toLocaleString()}</p>
                                                </div>
                                                <div style={{ borderTopColor: 'rgb(101, 101, 255)' }} className="card-footer">
                                                    <div className='d-flex align-items-center'>
                                                        <i className="fa fa-user fa-2x"></i>
                                                        <div className='d-flex flex-column px-3'>
                                                            <span className="text-light text-start">Metatech Official</span>
                                                            <span className="text-light text-opacity-75 text-start">{new Date(p.date || Date.now()).toDateString()}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                )
                            })}
                        </div>}
                        <div className="text-center mt-4">
                            <Link to="/blogs" onClick={() => window.scrollTo({ behavior: 'smooth', top: 0, left: 0 })} className="btn btn-outline-light rounded-4 px-4 py-2">View All Blogs</Link>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default BlogDetail
